import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { SpinnerIcon } from '../icons';
import './modal-payment-container.scss';

function ModalPaymentContainerIcon({ icon }) {
  return (
    <div className="modal-payment-card-icon-container" onClick={(e) => e.stopPropagation()}>
      <div className="modal-payment-card-icon">
        {icon}
      </div>
    </div>
  );
}

ModalPaymentContainerIcon.propTypes = {
  icon: PropTypes.node.isRequired,
};

function ModalPaymentCardContentHeader({ title, subtitle, children }) {
  return (
    <div className="modal-payment-card-content-header">
      <h2>{title}</h2>
      {subtitle && <h3>{subtitle}</h3>}
      {children}
    </div>
  );
}

ModalPaymentCardContentHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

function ModalPaymentCardContentBody({ children }) {
  return (
    <div className="modal-payment-card-content-body">{children}</div>
  );
}

function ModalPaymentCardContentButton({ onClick, text, loading }) {
  return (
    <div className="modal-payment-card-content-button">
      <button onClick={onClick} disabled={!!loading}>{(!loading)
        ? text
      : <SpinnerIcon className='loading' />
      }</button>
    </div>
  );
}

ModalPaymentCardContentButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};



function ModalPaymentCardContent({ headerTitle, headerSubtitle, buttonText, onButtonClick, children, headerContent, loadingButton }) {
  return (
    <div className="modal-payment-card-content" onClick={(e) => e.stopPropagation()}>
      {/*  Header */}
      <ModalPaymentCardContentHeader title={headerTitle} subtitle={headerSubtitle}>{headerContent}</ModalPaymentCardContentHeader>
      {/*  Body */}
      <ModalPaymentCardContentBody>{children}</ModalPaymentCardContentBody>
      {/*  Button */}
      {(onButtonClick != null) && <ModalPaymentCardContentButton
        onClick={onButtonClick}
        text={buttonText}
        loading={loadingButton}
      />}
    </div>
  );
}

ModalPaymentCardContent.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerSubtitle: PropTypes.string,
  headerContent: PropTypes.node,
  buttonText: (props) => {
    if (props.onButtonClick != null) {
      throw new Error('buttonText is required');
    }
  },
  onButtonClick: PropTypes.func,
};

function ModalPaymentContainer(props) {
  const {
    headerTitle,
    headerSubtitle,
    onButtonClick,
    buttonText,
    children,
    icon,
    headerContent,
    onClose,
    loadingButton,
  } = props;

  return (
    <div className="modal-payment-container" onClick={onClose}>
      <div className="modal-payment-close-button">
        <button>
          <FontAwesomeIcon icon={faTimes} size="2x" />
        </button>
      </div>
      <div className="modal-payment-card">
        <ModalPaymentContainerIcon icon={icon} />
        <ModalPaymentCardContent
          headerTitle={headerTitle}
          headerSubtitle={headerSubtitle}
          headerContent={headerContent}
          onButtonClick={onButtonClick}
          buttonText={buttonText}
          loadingButton={loadingButton}
        >{children}</ModalPaymentCardContent>
      </div>
    </div>
  );
}

ModalPaymentContainer.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerSubtitle: PropTypes.string,
  headerContent: PropTypes.node,
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.node,
  icon: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  loadingButton: PropTypes.bool,
}

export { ModalPaymentContainer };
